<template>
  <div 
    style="max-width: 500px; position: relative; height:100%; overflow: hidden;" 
    class="Kanit mx-auto bg-home">
    <!-- Header -->
    <Header :isHeaderFixed="false"></Header>

    <!-- Content Box -->
    <div class="wrapper-content-box"> 
      <div class="content-box">
        <p style="font-size: 18px; font-weight: 700; letter-spacing: 1px;">"&nbsp;<span style="color:#B6907D; ">JOY THE WRITE</span>&nbsp;"</p>
        <p>สิทธิพิเศษที่เหนือกว่ากับ<br><span style="font-weight: 700;">LAMY</span><br>รับสิทธิประโยชน์และของขวัญสุดพิเศษ</p>
        <p>สมัคร <span style="font-weight: 700;">LAMY CLUB</span> ง่ายๆ<br>
        และสะสมยอดซื้อ<br>
        จากการซื้อที่ร้าน <span style="font-weight: 700;">LAMY</span> ทุกสาขาที่ร่วมรายการ<br>
        หรือช็อปออนไลน์ พร้อมกับการลงทะเบียน<br>ใบรับประกันสินค้า รับประกันศูนย์<br> 2 ปี และสิทธิพิเศษเฉพาะสมาชิก<br>
        <span style="font-weight: 700;">LAMY CLUB</span> ทั้ง 2 ระดับทั้ง Silver และ Gold<br> member อาทิ ส่วนลดพิเศษ,<br> ซื้อสินค้าใหม่ก่อนใคร และรางวัล<br> Rewards อีกมากมาย</p>
      </div>

      <!-- Button -->
      <div class="mt-4">
        <v-row>
          <v-col cols="5">
            <v-btn
              tile
              dark
              color="#000"
              @click="changePage('home')"
              style="width: 100%; height: 48px;"
            >
              <v-icon left>
                mdi-arrow-left 
              </v-icon>
              ย้อนกลับ
            </v-btn>
          </v-col>
          <v-col cols="7">
            <v-btn
              tile
              dark
              color="#000"
              style="width: 100%;  height: 48px;"
              @click="changePage('/benefits-information')"
            >
              สิทธิประโยชน์สมาชิก
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div> <!-- wrapper-content-home -->
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  components: {
    Header
  },  
  methods: {
    changePage(name) {
      var path = "/"+name;
      if (this.$route.path !== path) {
        this.$router.push({
          path: name,
          query: {...this.$route.query } ,
        }).catch({});
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>